/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export interface IntroRequest {
  profile_id: string;
  /**
     * @minItems 1
     * @maxItems 20
     */
  member_ids: string[];
  /** @maxLength 2000 */
  message?: string;
}
